module.exports = __webpack_public_path__ + "assets/img/papier-vs-electro-archivage-securitaire.3be68125.jpg";